import { format } from 'date-fns';
import { useInterestedFilterStore, useInterestedStore } from 'src/stores/InterestedStore';
import { postSearchInterested } from 'src/api/Interested';
import { useDialogStore } from 'src/stores/DialogStore';

export const LoadInterestedData = async (pagination?:boolean) => {
  const {
    start_date,
    end_date,
    start_birth,
    end_birth,
    edu_level,
    highschool_type,
    gender,
    status,
    page_Num,
    setOpen,
    setField,
    sort_by,
    sort_order,
    student_name
  } = useInterestedFilterStore.getState();
  const { selected_Regions } = useDialogStore.getState();
  const { setResponse, setField: setFieldint, } = useInterestedStore.getState();
  const format_start_date = start_date ? format(start_date, 'yyyy-MM-dd') : '';
  const format_end_date = end_date ? format(end_date, 'yyyy-MM-dd') : '';
  const format_start_birth = start_birth ? format(start_birth, 'yyyy-MM-dd') : '';
  const format_end_birth = end_birth ? format(end_birth, 'yyyy-MM-dd') : '';

  const regionEntries = Object.entries(selected_Regions).map(([wide, cities]) => {
      const trimmedWide = wide.slice(0, 2);
      const filteredCities = cities.length === 1 && cities[0] === '전체' ? [] : cities;
      return [trimmedWide, filteredCities] as [string, string[]];
    });

  const response = await postSearchInterested({
    selected_Regions : regionEntries,
    page: pagination ? page_Num : 1,
    start_date: format_start_date,
    end_date: format_end_date,
    start_birth: format_start_birth,
    end_birth: format_end_birth,
    edu_level,
    highschool_type,
    gender,
    status,
    sort_by,
    sort_order,
    student_name
  });
  const nextPage = pagination ? page_Num + 1 : 2;
  if (!response?.data) return
  if (pagination && page_Num !== 1) {
    // console.log('페이지네이션');
    setResponse(response.data, nextPage);
    setField('page_Num', nextPage);
    setFieldint('total_rows',response.total_rows)
  } else {
    // console.log('셋필드');
    setField('page_Num', 2);
    setFieldint('response', response.data);
    setFieldint('total_rows',response.total_rows)
  }
  setOpen(false);
};
